import type { StudioApiClient } from "../../../api.js";
import { BatchAuditPanel } from "../../../BatchAuditPanel.js";

export function V10BatchAuditPanel({ api }: { readonly api: StudioApiClient }) {
  return (
    <div className="v10-scan-embedded-panel" aria-label="Batch audit">
      <BatchAuditPanel api={api} />
    </div>
  );
}
